import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from './map.component';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonModule } from 'primeng/skeleton';



@NgModule({
  declarations: [
    MapComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    SkeletonModule
  ],
  exports: [
    MapComponent
  ]
})
export class MapModule { }
